/**
 * App — top-level router and providers.
 *
 * Routes:
 *   "/"            → InvitePage (normal users enter an invitation code).
 *   "/admin"       → LobbyPage  (admin catalogue + room creation; admin token required).
 *   "/room/:roomId" → RoomPage  (the synchronized player; unchanged).
 *
 * Wrapped in a ToastProvider so any descendant can surface socket/async errors.
 */
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LobbyPage } from './pages/LobbyPage';
import { InvitePage } from './pages/InvitePage';
import { RoomPage } from './pages/RoomPage';
import { ToastProvider } from './components/ui/Toast';

/** Root application component: providers + routes. */
export function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<InvitePage />} />
          <Route path="/admin" element={<LobbyPage />} />
          <Route path="/room/:roomId" element={<RoomPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}
